module.exports = __webpack_public_path__ + "img/14.f2de73ac.jpeg";